import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { hasAllPermissions, hasPermission, ROUTER_PATHS, useCheckPermissions, useTableFilter } from '@/shared';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { Cooperativa } from '@/shared/interfaces';
import { PermissionsEnum } from '@/auth/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';
import { useFetchCooperativa, useUpdateCooperativa } from '@/shared/actions/erp/cooperativa.actions';

const returnUrlEntidades = '/parametrizacion/cooperativa';

export interface EntidadesFinancierasPageInterface { }

const CooperativaPage: React.FC<EntidadesFinancierasPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_entidadfinanciera)

  const navigate = useNavigate();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter
  } = useTableFilter();
  const { pageIndex } = pagination;
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  ///* fetch data
  const {
    data: EntidadesFinancierasPagingRes,
    isLoading,
    isRefetching,
    refetch,
  } = useFetchCooperativa({
    params: {
      page: pageIndex + 1,
      nombre: searchTerm,
    },
    enabled: true
  });

  ///* mutations
  const updSate = useUpdateCooperativa({
    enableRedirect: false,
    onSuccess: () => refetch(),
  })
  ///* handlers
  const onEdit = (original: Cooperativa) => {
    navigate(`${returnUrlEntidades}/editar/${original.id_cooperativa}`);
  };

  ///* columns
  const columns = useMemo<MRT_ColumnDef<Cooperativa>[]>(
    () => [
      {
        accessorKey: 'numero_referencia',
        header: 'Numero referencia',
        size: 300,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
      /*   {
          accessorKey: 'codigo',
          header: 'codigo',
          size: 300,
        }, */
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <SwitchComponente
              estadoSwitch={row.original.estado}
              titulo={row.original.estado ? 'Activo' : 'Inactivo'}
              setEstadoSwitch={state => {
                if (!hasPermission(PermissionsEnum.api_change_entidadfinanciera)) return;
                setConfirmDialog({
                  isOpen: true,
                  title: 'Cambiar Estado',
                  subtitle:
                    '¿Está seguro que desea cambiar el estado de este registro ?',
                  onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    updSate.mutate({
                      id: row.original.id_cooperativa!,
                      data: { estado: !!state } as any,
                    });
                  },
                });
              }}
            />
          );
        },
      },
    ],
    []
  );

  return (
    <SingleTableBoxScene
      title="Cooperativas"
      urlRedirect={ROUTER_PATHS.administration.cooperativa_crear}
      enableRedirect={hasPermission(PermissionsEnum.api_add_entidadfinanciera)}>
      <CustomSearch onChange={onChangeFilter}
        value={globalFilter} cleanFilter={cleanFilter}
        text="nombre de Cooperativa" />

      <GeneralTable<Cooperativa>
        columns={columns}
        data={EntidadesFinancierasPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={EntidadesFinancierasPagingRes?.data?.count}
        // // actions
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_entidadfinanciera,
        ])}
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_entidadfinanciera,
        ])}
        // crud
        onEdit={onEdit}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default CooperativaPage;
